import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuRefreshService {
  private refreshMenuSource = new Subject<void>();

  refreshMenu$ = this.refreshMenuSource.asObservable();

  triggerMenuRefresh() {
    //  console.log('Menu refresh triggered from service');
    this.refreshMenuSource.next();
  }
}
